// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportBar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import IconMenu from 'share/components/controls/Izenda.IconMenu';
import Button from 'share/components/controls/Izenda.Button';
import connect from 'share/enhancers/Izenda.Connect';
import FileUpload from 'share/components/controls/FileUpload/Izenda.FileUpload';
import Input from 'share/components/controls/Izenda.Input';
import actions from './Izenda.ImportBarActions';
import ImportErrorPopup from '../Popup/Izenda.ImportErrorPopup';
import { FILE_EXTENSION } from 'logic/data/Izenda.ImportConstants';
import { propTypes as MobxPropTypes } from 'mobx-react';
import { isEmpty, join } from 'lodash/fp';
import fetcher from 'share/fetch/Izenda.Fetch';

@connect(actions)
export default class ImportBar extends Component {
  static propTypes = {
    store: MobxPropTypes.observableObject
  };

  render() {
    const { props, props: { localization, store, store: { model } } } = this;
    const options = {
      baseUrl: 'importManagement/file',
      param: {
        batchId: String.newGuid()
      },
      requestHeaders: fetcher().getAuthHeader(),
      chooseAndUpload: true,
      multiple: true,
      accept: join([FILE_EXTENSION.REPORT, FILE_EXTENSION.DASHBOARD], ','),
      wrapperDisplay: 'inline',
      uploadSuccess: (content: any) => {
        store.appendContent(content);
        if (!isEmpty(content.invalidFileMessages)) {
          props.openPopup(ImportErrorPopup, { messages: content.invalidFileMessages, store });
        }
      }
    };

    return (
      <section className="izenda-Wrapper-header">
        <IconMenu className="u_marginRightInnerSpace" />

        <FileUpload options={options} isHighlight={false} className="u_inlineBlock" />
        <a>
          <span className="icon-info-circled" title={localization.getText('INSTRUCTION_BROWSE_FILES')} />
        </a>

        {/* Action Bar Right */}
        <div className="izenda-ActionBarRight">
          <Input type="checkbox" checked={model.importCategory} onChange={props.updateImportCategory} />
          <span className="u_marginLeftInnerSpace u_textNormal u_marginBottomSmall">
            {localization.getText('IMPORT_THE_SOURCE_CATEGORY_SUBCATEGORY')}
          </span>
          <a>
            <span
              className="icon-info-circled"
              title={localization.getText('TOOLTIP_IMPORT_THE_SOURCE_CATEGORY_SUBCATEGORY')}
            />
          </a>
          <Input className="u_marginLeft" type="checkbox" checked={model.importAccessRights} onChange={props.updateImportAccessRights} />
          <span className="u_marginLeftInnerSpace u_textNormal u_marginBottomSmall">
            {localization.getText('IMPORT_THE_SOURCE_ACCESS_RIGHT')}
          </span>
          <a>
            <span
              className="icon-info-circled"
              title={localization.getText('TOOLTIP_IMPORT_THE_SOURCE_ACCESS_RIGHT')}
            />
          </a>
          <Input
            className="u_marginLeft"
            type="checkbox"
            checked={model.importFilterValues}
            onChange={props.updateImportTheFilterValues}
          />
          <span className="u_marginLeftInnerSpace u_textNormal u_marginBottomSmall">
            {localization.getText('IMPORT_THE_FILTER_VALUES')}
          </span>
          <a>
            <span
              className="icon-info-circled"
              title={localization.getText('TOOLTIP_IMPORT_THE_FILTER_VALUES')} />
          </a>
          <Button label={localization.getText('COMMON_LABEL_IMPORT')} onClick={this.props.startImportProcess}/>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/ActionBar/Izenda.ImportBar.js